import { render, staticRenderFns } from "./SvgSymbols.vue?vue&type=template&id=323cc966&"
import script from "./SvgSymbols.vue?vue&type=script&lang=js&"
export * from "./SvgSymbols.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports